import { Store } from '@ngrx/store';
import { environment } from './../../../environments/environment';
import { UserModel, OrgModel } from './../../store/storeModels/user.model';
import { HttpClient } from '@angular/common/http';
import { Endpoints } from 'src/app/shared/config/endpoints';
import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import * as io from 'socket.io-client';
import { TicketChatModel } from 'src/app/models/ticket/ticket.model';
import { GeneralService } from '../general.service';
import { AppState } from 'src/app/store/app.state';
@Injectable({
  providedIn: 'root'
})
export class TicketChatService {

  socket: any;
  readonly socketUrl: string = environment.chatServiceUrl//'http://localhost:3500'
  readonly api: string = this.endpoint.ticketUrl;
  private orgId;
  private org: OrgModel;
  private user: UserModel;
  private userChatId
  private notchOrgData = environment.notchTenantInfo;

  constructor(
    private endpoint: Endpoints,
    private http: HttpClient,
    private gs: GeneralService,
    store: Store<AppState>) {
    store.select('userInfo').subscribe(info => {
      this.orgId = info.organization.id + '';
      this.org = info.organization;
      this.user = info.user;
      const [username, domain] = info.user.email.split('@');
      this.userChatId = `${username}+${this.org.id}@${domain}`;
    })
    this.socket = io(this.socketUrl);
    this.socket.on('connect', () => {
    })
  }
  listen(eventName: string) {
    return new Observable((subcriber) => {
      this.socket.on(eventName, (data) => {
        subcriber.next(data);
      })
    })
  }
  emit(eventName: string, data: any) {
    return new Observable((subcriber) => {
      this.socket.emit(eventName, data, () => {
        subcriber.next()
      })
    })
  }
  newMsg() {
    return this.listen('new message')
  }
  joinChat() {
    return this.socket.emit('join PM', {
      user: this.orgId,
      org: this.orgId,
      source: 'admin'
    })
  }
  joinWebchat(ticketCode) {
    return this.emit('join PM', {
      user: ticketCode,
      org: this.notchOrgData.id,
      source: 'web-chat'
    })
  }
  sendWebChatSocketMsg({ ticketCode, msg }) {
    const payload = {
      msg,
      sender: this.userChatId,
      sendTo: this.notchOrgData.id,
      source: 'WEBSITE',
      location: '',
      ticketCode,
    }
    return this.emit('private message', payload);
  }
  recieveWebChatMsg() {
    return this.listen('new message');
  }
  fetchOnlineUsers() {
    return this.listen('usersList');
  }
  sendMessage({ msg, sendTo, isClosed }) {
    const data = {
      msg,
      sender: this.orgId,
      sendTo,
      agentID: this.user.id,
      groupID: this.user.groupID,
      isClosed,
      agentName: `${this.user.firstName} ${this.user.lastName}`,
      agentPix: this.user.userImg || 'https://res.cloudinary.com/dx5bcp5ps/image/upload/v1591821429/avatar-icon-png-8_txuved.png'
    }
    return this.emit('private message', data)
  }
  sendWhatsMsg(payload) {
    const body = {
      orgID: this.orgId,
      to: payload.to,
      body: payload.message
    }
    if(payload.whatsappSetup === 'vonage'){
      return this.http.post(this.socketUrl + '/bots/whatsapp/vonage/send_message', body)
    } else {
      return this.http.post(this.socketUrl + '/bots/whatsapp/clickatel/send_message', body)
    }
  }
  sendTwitterMsg(payload) {
    const body = {
      ...payload,
      body: `${payload.body}\n\n From ${this.user.firstName}`,
      recipient_id: payload.userId || payload.user_id
    }
    const url = environment.twitterServiceUrl//'http://9cfb94face8f.ngrok.io' ;
    return this.http.post(url + '/streams/reply/direct-message', body);
  }
  sendFacebookMsg(payload) {
    const body = {
      ...payload,
      orgId: this.org.id,
      newMessage: `${payload.newMessage}\n\n ${this.user.firstName || "Agent"} from ${this.org.name}`,
      // user_id: payload.userId || payload.user_id
    }
    const url = environment.facebookServiceUrl//'http://9cfb94face8f.ngrok.io' ;
    return this.http.post(url + '/pages/response/message', body);
  }

  sendInstagramMsg(payload) {
    const body = {
      ...payload,
      orgId: this.org.id,
      newMessage: `${payload.newMessage}\n\n ${this.user.firstName || "Agent"} from ${this.org.name}`,
    }
    const url = environment.instagramServiceUrl;
    return this.http.post(url + '/pages/response/message', body);
  }

  saveChat(payload: TicketChatModel) {
    const user = this.user;
    const actionBy = `${user.firstName} ${user.lastName}`
    const body = {
      ...payload,
      agentID: this.user.id,
      groupID: this.user.groupID,
      orgID: this.orgId,
      agentPix: this.user.userImg,
      agentName: actionBy,
      subject: payload.subject ? payload.subject : 'ENQUIRY',
      chatBy: 'AGENT',
      actionBy
    }  
    return this.http.post(this.api + '/sendToSite', body)
  }
  fetchChat(code) {
    return this.http.get<any>(this.api + `/${code}/getTicketChats`);
  }
  getTicketByCode(code: string) {
    return this.http.get<any>(`${this.api}/${code}/getTicketByCode`);
  }
  fectchOnlineUsersObj() {
    return this.http.get(this.socketUrl + `/ticket/online-user/${this.orgId}`)
  }
  JoinCallNotifier() {
    return this.emit('join_call_notify', { orgId: this.orgId })
  }
  recieveIncomingCall() {
    return this.listen('agent_incoming_call_notify')
  }
  disconnect() {
    return this.socket.emit('disconnect')
  }
  getChatsByClient() {
    return this.http.get<any>(`${this.api}/${this.userChatId}/getChatsByClient`);
  }
  sendWebChatMsg(payload: {
    message: string,
    ticketCode?: string,
    subject?: string,
    ticketType?: string,
    location?: string
  }, endpoint = 'getSiteChats') {
    const body = {
      channel: 2,
      orgID: this.notchOrgData.id,
      orgName: this.notchOrgData.name,
      sender: this.userChatId,
      subject: 'Webchat Message',
      ticketType: 'ENQUIRY',
      ...payload
    };
    return this.http.post<any>(`${this.api}/${endpoint}`, body)
  }
  getAutoReplyMsg() {
    return this.http.get<any>(`${this.api}/autoReply/${this.notchOrgData.id}/2`)
  }

  fetchChatForInternalResponse(code) {
    return this.http.get<any>(this.api + `/${code}/getInternalResponseTicketChats`);
  }
  
}
